export default "__VITE_ASSET__B2npy5Yu__"